import { serverResponse } from 'app'

import * as actions from '../../actions/platform'

export default (state = actions.getPlatformInitialState(), action = {}) => {
  switch (action.type) {
    case actions.PLATFORM_DATA_FETCH: {
      return serverResponse(state, { loading: true })
    }
    case actions.PLATFORM_DATA_FETCH_CANCELED: {
      return serverResponse(state)
    }
    case actions.PLATFORM_DATA_FETCH_ERROR: {
      return serverResponse(state, action.payload, { loaded: true })
    }
    case actions.PLATFORM_DATA_FETCH_FULFILLED: {
      return serverResponse(action.payload, { loaded: true })
    }

    default:
  }
  return state
}
